var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBloomModalSearchSkuLabel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6 12C9.31371 12 12 9.31371 12 6C12 2.68629 9.31371 0 6 0C2.68629 0 0 2.68629 0 6C0 9.31371 2.68629 12 6 12ZM3.88 2C4.9183 2 5.76 2.8417 5.76 3.88V4.72C5.76 5.55947 6.44053 6.24 7.28 6.24H8.12C9.15829 6.24 10 7.0817 10 8.12C10 9.15829 9.15829 10 8.12 10C7.0817 10 6.24 9.15829 6.24 8.12V7.28C6.24 6.44053 5.55947 5.76 4.72 5.76H3.88C2.8417 5.76 2 4.9183 2 3.88C2 2.8417 2.8417 2 3.88 2ZM9.68 3.88C9.68 4.74156 8.98156 5.44 8.12 5.44C7.25844 5.44 6.56 4.74156 6.56 3.88C6.56 3.01844 7.25844 2.32 8.12 2.32C8.98156 2.32 9.68 3.01844 9.68 3.88ZM5.44 8.12C5.44 8.98156 4.74156 9.68 3.88 9.68C3.01844 9.68 2.32 8.98156 2.32 8.12C2.32 7.25844 3.01844 6.56 3.88 6.56C4.74156 6.56 5.44 7.25844 5.44 8.12Z",
    fill: "#5062F0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBloomModalSearchSkuLabel);
export default __webpack_public_path__ + "static/media/bloomModalSearchSkuLabel.92c380c556bd1d67d8fbf7e9a61e92f4.svg";
export { ForwardRef as ReactComponent };